export default function PageHeader({ overline, title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div className="min-w-0">
        {overline && <div className="brand-overline mb-1">{overline}</div>}
        <h1 className="font-display font-bold text-2xl sm:text-3xl text-[#222] tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-[#6C757D] mt-1 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
